export default {
  agenciaPA: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/contacts/internal/components/search/search-form.js